<div>

  @if (error) {
    <div class="example-box">
      {{error | json}}
    </div>
  }

  <h3>Solution (guid ID)</h3>

  <input kendoTextBox [(ngModel)]="solutionId" style="width: 300px;" />

  <h3>Flows</h3>

  <ul>
    @for (flow of this.flows; track flow) {
      <li>{{flow.displayName}}
        @if (flow.sharingType.includes('CommonDataService')) {
          <fa-icon icon="folder-open" title="Is already Solution Aware" [ngStyle]="{'color': '#742873' }"></fa-icon>
        }
      </li>
    }
  </ul>

  <div style='margin-top:10px;'>
    <button kendoButton (click)="this.makeSolutionAware()" themeColor="primary">Make Solution Aware</button>
    <button kendoButton (click)="this.onClose()" >Close</button>
  </div>

</div>
